import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const GhostIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Ghost",
    children: /*#__PURE__*/_jsx("path", {
      d: "M14.59 30a6.47 6.47 0 0 1-3.88-1.36h.01c-.19-.14-.39-.3-.58-.46-.26-.24-.55-.47-.86-.67l-.03-.02c-.35-.2-.76-.39-1.19-.54l-.05-.02c-.87-.26-1.62-.7-2.24-1.28-.61-.7-.98-1.63-.98-2.64q0-.255.03-.51v.02-9.64C5 6.83 9.94 2 16.01 2S27.03 6.83 27.2 12.86v11.16c0 1.33-.58 2.51-1.51 3.33-1.09.82-2.38.71-3.62.61-.29-.04-.63-.06-.97-.06s-.68.02-1.01.07h.04c-.79.19-1.48.5-2.11.9l.03-.02c-.6.38-1.29.71-2.02.95l-.07.02c-.41.12-.89.19-1.38.19Zm1.38-26.98c-5.44 0-9.85 4.42-9.87 9.86v9.76a2.687 2.687 0 0 0 .61 2.13c.49.43 1.08.75 1.74.93h.03c.56.2 1.05.42 1.5.68l-.04-.02c.41.26.76.53 1.09.82.18.14.34.28.53.42a4.79 4.79 0 0 0 4.14.95h-.03c.68-.22 1.26-.5 1.8-.84l-.04.02c.71-.45 1.54-.81 2.43-1.02h.05c.34-.06.74-.08 1.14-.08s.8.03 1.19.08h-.05c1.09.08 2.03.16 2.71-.36.59-.6.96-1.42.96-2.32 0-.1 0-.2-.01-.3s0-10.83 0-10.83c0-5.46-4.43-9.88-9.89-9.88Zm-3.18 8.01a1.23 1.23 0 1 1-2.46 0 1.23 1.23 0 1 1 2.46 0m8.83 0a1.23 1.23 0 1 1-2.46 0 1.23 1.23 0 1 1 2.46 0m-3.87 4.55h-3.54c-.36 0-.66-.3-.66-.66s.3-.66.66-.66h3.54c.36 0 .66.3.66.66s-.3.66-.66.66"
    })
  }));
};